import { render, staticRenderFns } from "./modalStatusServiceTicket.vue?vue&type=template&id=493f2e9e&"
import script from "./modalStatusServiceTicket.vue?vue&type=script&lang=js&"
export * from "./modalStatusServiceTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports